import React, { useState } from 'react';
import { ArrowRightIcon, XIcon, LayersIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FluidWebModal } from './FluidWebModal';
const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  if (!isVisible) return null;
  return <>
      <AnimatePresence data-id="element-49">
        <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="bg-gray-900 text-white" data-id="element-50">
          <div className="container mx-auto px-4 py-2.5 flex items-center justify-center relative" data-id="element-51">
            <p className="text-sm font-medium text-center pr-8 flex items-center gap-2 flex-wrap justify-center" data-id="element-52">
              <span className="inline-flex items-center gap-1.5 bg-white/10 px-2 py-0.5 rounded-full text-xs font-semibold text-orange-300" data-id="element-53">
                <LayersIcon size={12} data-id="element-54" />
                FluidWeb
              </span>
              <span className="text-gray-300" data-id="element-55">
                FluidForm is built on FluidWeb — the platform for reliable
                agentic interfaces.
              </span>
              <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center gap-1 text-orange-400 hover:text-orange-300 transition-colors group font-semibold" data-id="element-56">
                Learn more
                <ArrowRightIcon size={14} className="group-hover:translate-x-0.5 transition-transform" data-id="element-57" />
              </button>
            </p>
            <button onClick={() => setIsVisible(false)} className="absolute right-4 text-gray-400 hover:text-white transition-colors" aria-label="Close announcement" data-id="element-58">
              <XIcon size={16} data-id="element-59" />
            </button>
          </div>
        </motion.div>
      </AnimatePresence>
      <FluidWebModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-60" />
    </>;
};
export default AnnouncementBar;